function placeholderClassName(aspectRatio) {
  return aspectRatio === "form" ? "min-h-[280px]" : "aspect-video";
}

export default function EmbedFrame({ embedHtml, embedUrl, title, placeholderLabel, aspectRatio = "video" }) {
  if (embedHtml) {
    return (
      <div
        className={`embed-frame rounded-2xl border border-border bg-card shadow-soft overflow-hidden ${aspectRatio === "form" ? "embed-frame-form min-h-[280px]" : ""}`.trim()}
        dangerouslySetInnerHTML={{ __html: embedHtml }}
      />
    );
  }

  if (embedUrl) {
    return (
      <div className={`rounded-2xl overflow-hidden border border-border bg-card shadow-soft ${placeholderClassName(aspectRatio)}`}>
        <iframe
          src={embedUrl}
          title={title}
          className="w-full h-full min-h-[280px]"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className={`rounded-2xl border border-dashed border-secondary/45 bg-card shadow-soft flex items-center justify-center p-8 ${placeholderClassName(aspectRatio)}`}>
      <div className="text-center max-w-md">
        <p className="font-sans text-lg font-semibold text-foreground mb-2">{placeholderLabel || title}</p>
        <p className="font-body text-muted-foreground">
          Add the live embed code or embed URL in the content files to replace this placeholder.
        </p>
      </div>
    </div>
  );
}
